<template>
  <div v-loading="loading">
    <el-card shadow="never" v-for="(row, index) in formdata" :key="index">
      <div slot="header" class="toolbar">
        <h1>{{ row.CustomerName }}</h1>
        <el-button size="small" type="primary" @click="onSubmit(index)">提交表单</el-button>
      </div>
      <el-form :ref="'form' + index" :model="row" size="small" label-position="top">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item prop="Linkman">
              <el-input v-model="row.Linkman" clearable placeholder="联系人" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="Linktel">
              <el-input v-model="row.Linktel" clearable placeholder="电话" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="Address">
              <el-input v-model="row.Address" clearable placeholder="收货地址" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item prop="Remark">
          <el-input v-model="row.Remark" clearable placeholder="订单备注" />
        </el-form-item>
        <el-table :data="row.items" size="mini" border>
          <el-table-column label="库存编码" width="120">
            <template slot-scope="{ row }">
              {{ $utils.meta.format('branch', row.Stock) }}
              {{ row.Code }}
            </template>
          </el-table-column>
          <el-table-column prop="Name" label="商品名称" min-width="200" show-overflow-tooltip />
          <el-table-column prop="Unit" label="单位" align="center" width="60" />
          <el-table-column label="设置发货数量" width="160" align="right">
            <template slot-scope="{ row }">
              <el-input-number v-model="row.Amount" :min="1" :max="row.Max" size="mini" />
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  props: {
    goods: { type: Array }
  },
  data () {
    return {
      loading: false,
      formdata: null
    }
  },
  created () {
    let _goods = this.goods.map(item => {
      return {
        CustomerId: item.CustomerId,
        OrderId: item.Order.Id,
        GoodsId: item.Goods.Id,
        ParentId: item.Goods.Parent,
        Stock: item.Goods.Stock,
        Code: item.Goods.Code,
        Name: item.Goods.Name,
        Unit: item.Goods.Unit,
        Amount: item.Amount - item.Parcels,
        Max: item.Amount - item.Parcels,
      }
    })
    this.formdata = this.$utils.common.DataGroup(_goods, "CustomerId").map(row => {
      this.loadCustomer(row)
      return row
    })
  },
  methods: {
    loadCustomer (row) {
      this.$apis.organize.customer.info({ id: row.type }).then(res => {
        this.$set(row, "CustomerId", res.Id)
        this.$set(row, "CustomerName", res.Name)
        this.$set(row, "Linkman", res.Linkman)
        this.$set(row, "Linktel", res.Linktel)
        this.$set(row, "Address", res.Address)
      })
    },

    //提交发货单
    onSubmit (index) {
      this.$refs['form' + index][0].validate(valid => {
        if (valid && !this.loading) {
          this.loading = true
          this.$apis.mall.parcel.submit(this.formdata[index]).then(() => {
            this.$message({ message: "数据提交成功！", type: "success" })
            //移除父页面数据
            this.formdata[index].items.forEach(item => {
              this.goods.splice(
                this.goods.findIndex(x =>
                  x.Order.Id == item.OrderId
                  && x.Goods.Parent == item.ParentId
                  && x.Goods.Id == item.GoodsId
                ), 1)
            })
            this.$emit('update:goods', this.goods)
            //移除表单数据
            this.formdata.splice(index, 1)
          }).catch(e => {
            this.$message.error(e || "执行错误")
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>


<style lang="scss" scoped>
:deep(.el-card) {
  margin: 20px;
  &__header {
    padding: 10px 20px;
    background: #f2f6fc;
    h1 {
      font-size: 18px;
    }
  }
}
</style>